import React from "react";
import { Button } from "../../../components/ui";
import { totalRow } from "../helpers";

export default function ProductRow({
  product,
  idx,
  availableProducts,
  updateProduct,
  removeProduct
}) {
  const selectedProduct = availableProducts.find(prod => prod.id === product.product_id);

  return (
    <div className="product-row grid grid-cols-1 md:grid-cols-4 gap-2 mb-3 p-3 border rounded-lg">
      <div>
        <label className="block text-sm font-medium mb-1">Product</label>
        <select
          value={product.product_id}
          onChange={(e) => updateProduct(idx, 'product_id', e.target.value)}
          className="w-full p-2 border rounded-md"
        >
          <option value="">Select a product</option>
          {availableProducts.map(p => (
            <option key={p.id} value={p.id}>
              {p.name} - {p.brand}
            </option>
          ))}
        </select>
      </div>

      {selectedProduct && (
        <div>
          <label className="block text-sm font-medium mb-1">Size</label>
          <select
            value={product.size_variant}
            onChange={(e) => updateProduct(idx, 'size_variant', e.target.value)}
            className="w-full p-2 border rounded-md"
          >
            <option value="">Select size</option>
            {selectedProduct.sizes.map(size => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium mb-1">Price</label>
        <input
          type="number"
          step="0.01"
          value={product.price}
          onChange={(e) => updateProduct(idx, 'price', e.target.value)}
          className="w-full p-2 border rounded-md"
          placeholder="Select size first"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Quantity</label>
        <input
          type="number"
          placeholder="Qty"
          value={product.quantity}
          onChange={(e) => updateProduct(idx, 'quantity', e.target.value)}
          className="w-full p-2 border rounded-md"
        />
      </div>

      <div className="md:col-span-4 flex justify-between items-center mt-2">
        <div className="text-sm font-medium">Total: ₹{totalRow(product)}</div>
        <Button
          variant="outline"
          size="sm"
          onClick={removeProduct}
          className="text-red-600 hover:text-red-700"
        >
          Remove
        </Button>
      </div>
    </div>
  );
}

